import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { FileText, Mail } from "lucide-react";
import api from "@/lib/api";

export const LeadMagnet = () => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contract-lead", form);
      setSent(true);
      toast.success("Fac-simile inviato! Controlla la tua email.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nell'invio");
    } finally { setSending(false); }
  };

  return (
    <section className="py-20 md:py-24 bg-[#1a4a8a] text-white" data-testid="lead-magnet-section">
      <div className="container-editorial grid grid-cols-12 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.7 }}
          className="col-span-12 md:col-span-6"
        >
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-white flex items-center gap-2">
            <FileText size={13}/> — Trasparenza totale
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.0] mt-4">
            Scarica gratis il<br/><em className="italic text-white">fac-simile del contratto.</em>
          </h2>
          <p className="mt-5 text-white max-w-md text-sm leading-relaxed">
            Prima ancora di parlarci, leggi esattamente cosa firmi: nessun anticipo, compenso solo al successo. Te lo inviamo subito via email.
          </p>
        </motion.div>
        <div className="col-span-12 md:col-span-6">
          {sent ? (
            <p className="text-lg font-medium text-white" data-testid="contract-lead-success">
              ✓ Inviato a {form.email} — controlla la casella (anche lo spam).
            </p>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-4" data-testid="contract-lead-form">
              <input required minLength={2} placeholder="Il tuo nome" data-testid="contract-lead-name"
                className="bg-white/10 border border-white/20 rounded-lg px-5 py-3.5 text-sm placeholder-white/50 focus:border-[#CBD5E1] outline-none"
                style={{ transition: "border-color 200ms ease" }}
                value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}/>
              <input required type="email" placeholder="La tua email" data-testid="contract-lead-email"
                className="bg-white/10 border border-white/20 rounded-lg px-5 py-3.5 text-sm placeholder-white/50 focus:border-[#CBD5E1] outline-none"
                style={{ transition: "border-color 200ms ease" }}
                value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}/>
              <button type="submit" disabled={sending} data-testid="contract-lead-submit"
                className="bg-white text-[#2d6fc4] font-medium rounded-lg px-6 py-3.5 text-sm inline-flex items-center justify-center gap-2 hover:bg-[#CBD5E1] disabled:opacity-60"
                style={{ transition: "background-color 200ms ease" }}>
                <Mail size={15}/> {sending ? "Invio…" : "Inviami il fac-simile gratuito"}
              </button>
              <p className="text-[11px] text-white">Nessuno spam: riceverai solo il documento e, se vorrai, una consulenza gratuita.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
